import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Divider, Grid, useMediaQuery, useTheme } from "@mui/material";

import {
  useGetDeviceVendorsQuery,
  useGetDevices4gTotalQuery,
  useGetDevices5gTotalQuery,
  useGetChipsetsQuery,
  useGetAllocationsTotalQuery,
} from "../../store/apis/search";
import { getOperators, selectOperatorsTotal } from "../../store/slices/operators";
import DashboardMetricsItem from "./DashboardMetricsItem";

const DashboardMetrics: React.FC = () => {
  const dispatch = useDispatch<any>();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("lg"));
  const operatorsTotal = useSelector(selectOperatorsTotal);
  const deviceVendors = useGetDeviceVendorsQuery();
  const chipsets = useGetChipsetsQuery({ rowsPerPage: 1 });
  const vendorsTotal = deviceVendors.data?.length || 0;
  const chipsetsTotal = chipsets.data?.total || 0;
  const { data: allocationsTotal = 0 } = useGetAllocationsTotalQuery();
  const { data: devices4gTotal = 0 } = useGetDevices4gTotalQuery();
  const { data: devices5gTotal = 0 } = useGetDevices5gTotalQuery();

  useEffect(() => {
    dispatch(getOperators());
  }, [dispatch]);

  useEffect(() => {
    sessionStorage.setItem("devices5gTotal", devices5gTotal + "");
    sessionStorage.setItem("devices4gTotal", devices4gTotal + "");
    sessionStorage.setItem("operatorsTotal", operatorsTotal + "");
    sessionStorage.setItem("vendorsTotal", vendorsTotal + "");
    sessionStorage.setItem("chipsetsTotal", chipsetsTotal + "");
    sessionStorage.setItem("allocationsTotal", allocationsTotal + "");
  }, [devices5gTotal, devices4gTotal, operatorsTotal, vendorsTotal, chipsetsTotal, allocationsTotal]);

  return (
    <Grid container alignItems="flex-end">
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box paddingY={4}>
          <Grid container alignItems="flex-end">
            <Grid size={{ xs: 4 }} data-testid="devices5gTotal">
              <DashboardMetricsItem title="5G Devices" value={devices5gTotal} />
            </Grid>
            <Grid size={{ xs: 4 }} data-testid="devices4gTotal">
              <DashboardMetricsItem title="4G Devices" value={devices4gTotal} />
            </Grid>
            <Grid size={{ xs: 4 }} data-testid="operatorsTotal">
              <DashboardMetricsItem title="Operators" value={operatorsTotal} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        {mobile && <Divider />}
        <Box paddingY={4}>
          <Grid container alignItems="flex-end">
            <Grid size={{ xs: 4 }} data-testid="vendorsTotal">
              <DashboardMetricsItem title="Vendors" value={vendorsTotal} />
            </Grid>
            <Grid size={{ xs: 4 }} data-testid="chipsetsTotal">
              <DashboardMetricsItem title="Chipsets" value={chipsetsTotal} />
            </Grid>
            <Grid size={{ xs: 4 }} data-testid="allocationsTotal">
              <DashboardMetricsItem title="Spectrum Assignment" value={allocationsTotal} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardMetrics;
